export default "__VITE_ASSET__DpJYhUtg__"